import { useNoticeDetail } from "@/hooks/useNoticeDetail";
import { ChevronDown } from "lucide-react";

// \n을 <br>로 변환하는 함수
const formatContent = (content: string) => {
  if (!content) return "";
  // 실제 줄바꿈 문자(\n)와 문자열 "\n" 둘 다 처리
  return content
    .replace(/\\n/g, "<br>") // 문자열 "\n" 처리
    .replace(/\n/g, "<br>") // 실제 줄바꿈 문자 처리
    .replace(/\r\n/g, "<br>") // Windows 줄바꿈 처리
    .replace(/\r/g, "<br>"); // Mac 줄바꿈 처리
};

const formattingDate = (dateString: string) => {
  try {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  } catch {
    return dateString.split("T")[0] || dateString;
  }
};

// 공지사항 아이템 컴포넌트
export function NoticeItem({
  item,
  index,
  isOpen,
  onToggle,
}: {
  item: { id: number; title: string; is_pinned: boolean; created_at: string };
  index: number;
  isOpen: boolean;
  onToggle: () => void;
}) {
  // 항상 detail을 가져와서 클릭 시 즉시 표시
  const { data: noticeDetail } = useNoticeDetail(item.id, true);

  return (
    <div
      className={`grid grid-cols-[60px_585px_120px_50px] ${
        isOpen ? "grid-rows-[min-content_1fr]" : "grid-rows-[min-content_0fr]"
      } gap-x-2.5 border border-transparent border-b-[#D6D6DE] transition-all duration-[400ms] ${
        isOpen ? "bg-[#e8f1ff]" : "hover:bg-[#efefef]"
      }`}
      onClick={onToggle}
    >
      <div className="text-[15px] leading-10 text-center">{index + 1}</div>
      <div className="text-[15px] leading-10 text-left cursor-pointer">
        {item.is_pinned && (
          <span className="text-sig font-semibold mr-2">[공지]</span>
        )}
        {item.title}
      </div>
      <div className="text-[15px] leading-10 text-center">
        {formattingDate(item.created_at)}
      </div>
      <div className="text-[15px] leading-10 text-center flex items-center justify-center">
        <ChevronDown
          className={`w-4 h-4 text-gray-500 transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </div>

      {isOpen && (
        <div className="col-span-4 overflow-hidden bg-white">
          <div className="border-t border-[#D6D6DE] pt-6 pb-6 px-[60px]">
            {noticeDetail && (
              <>
                <div className="mb-2 text-sm text-gray-500">
                  작성자: {noticeDetail.author_name}
                </div>
                <div
                  className="whitespace-pre-line"
                  style={{ fontFamily: "inherit", lineHeight: "1.6" }}
                  dangerouslySetInnerHTML={{
                    __html: formatContent(noticeDetail.content),
                  }}
                ></div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
